module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SecurityVerifyView.js"));
	}, "SecurityVerifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SecurityVerifyView!./src/pages/Shop/Member/Wallet/PayPwd/SecurityVerify/SecurityVerifyView.js
// module id = 1994
// module chunks = 367